import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { GetEngementBO, GetTicketsBO } from '../ticket.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TicketEntryService extends Subject<DataStateChangeEventArgs>{

  constructor(private http: HttpClient, public errorService: ErrorService,
     public global: GlobalComponent, public general: GeneralService) {
    super();
  }


  public executeViewList(state: GetEngementBO): void {
    this.getTicketsViewList(state).subscribe(x => super.next(x));
}
getTicketsViewList(state?: GetEngementBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Tickets/GetEngements", state)
        .pipe(map(
            (response: any) =>
            (<any>{
                result: response['result'],
                count: response['count']
            })))
        .pipe(map((e: any) => {
            console.log(e,"rtrsdfds");
            
            return e;
        })
        )
}
}
